// extracted by mini-css-extract-plugin
module.exports = {"container":"container-o4C8T","icon":"icon-DDcM1"};